import { useState, useEffect } from "react";

export function toCommas(value) {
  return value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
export function createInvoiceSms(data) {
  const { total, totalAmountReceived, balanceDue, company, items } = data;

  const itemsList = items
    .map((item) => `${item.itemName} x ${item.quantity}`)
    .join("\n");

  const message =
    `Invoice No: ${data.id}%0A` +
    `Items:%0A${itemsList}%0A` +
    `Total: ${total} Tnd%0A` +
    `Amount Paid:${totalAmountReceived} Tnd%0A` +
    `Balance Due:${balanceDue} Tnd%0A` +
    `Phone: ${company.phoneNumber}%0A` +
    `${company.businessName}`;

  // Truncate the message if it exceeds 160 characters
  return message.length <= 160 ? message : message.substring(0, 160);
}
export const priceFormatter = (price) => {
  const numberValue = parseFloat(price);
  const formattedNumber = numberValue.toFixed(2);
  return formattedNumber;
};
export function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    // Update debouncedValue after the specified delay
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    // Clear the timeout if value or delay changes (e.g., on each keypress)
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}
export const formateDate = (date) => {
  const dateObject = new Date(date);

  const day = dateObject.getUTCDate() + 1;
  const month = dateObject.getUTCMonth() + 1;
  const year = dateObject.getUTCFullYear();

  return `${day}/${month}/${year}`;
};
